"use client";

import { usePathname } from "next/navigation";
import DeviceIdLogic from "components/layouts/Header/DeviceIdLogic";
import UsersCurrencyLogic from "components/layouts/Header/UsersCurrencyLogic";
import { PARTNER_CAMPAIGN_BANNER_HEIGHT_CSS_VAR, shouldShowPartnerCampaignBanner } from "features/partner-campaigns/campaign";
import { usePartnerCampaign } from "features/partner-campaigns/usePartnerCampaign";
import { isPresidentsDayDealsContext } from "utils/presidentsDayDeals";
import AppHeaderInner from "./AppHeaderInner";
import HeaderAlert from "./HeaderAlert";
const AppHeaderNewHome = () => {
  const pathname = usePathname();
  const isPaymentPage = pathname?.startsWith("/payment");
  const isPresidentsDeals = isPresidentsDayDealsContext(pathname);
  const isHomePage = ["/", "/signup", "/login", "/ta-login", "/about-us"].includes(pathname || "") && !isPresidentsDeals;
  const partnerCampaign = usePartnerCampaign();
  const hasPartnerCampaignBanner = !!partnerCampaign && shouldShowPartnerCampaignBanner(pathname);
  const partnerBannerOffset = `var(${PARTNER_CAMPAIGN_BANNER_HEIGHT_CSS_VAR}, 44px)`;
  const isHeaderFixed = !isHomePage;
  const headerThemeClassName = isPresidentsDeals ? "presidents-day-header bg-[#C6F0F6] text-[#0B4F57]" : isHomePage ? "bg-transparent text-white" : "bg-primary-500 text-white";
  return <>
      <HeaderAlert data-sentry-element="HeaderAlert" data-sentry-source-file="AppHeader.tsx" />
      <div className={`${isHeaderFixed ? "fixed left-0 right-0 top-0 " : "relative "} ${isPaymentPage ? "hidden md:block" : ""} z-[900] w-full ${headerThemeClassName}`} style={isHeaderFixed && hasPartnerCampaignBanner ? {
      top: partnerBannerOffset
    } : undefined}>
        <AppHeaderInner data-sentry-element="AppHeaderInner" data-sentry-source-file="AppHeader.tsx" />
      </div>
      {isHeaderFixed && <div className={`${isPaymentPage ? "hidden md:block" : ""} min-h-[60px] md:min-h-[80px]`}>
          {/* this is added to add space on top of content such that contant doesn't hide behind header */}
        </div>}
      <DeviceIdLogic data-sentry-element="DeviceIdLogic" data-sentry-source-file="AppHeader.tsx" />
      <UsersCurrencyLogic data-sentry-element="UsersCurrencyLogic" data-sentry-source-file="AppHeader.tsx" />
    </>;
};
export default AppHeaderNewHome;